import script from "./NoticiasHome.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiasHome.vue?vue&type=script&setup=true&lang=js"

import "./NoticiasHome.vue?vue&type=style&index=0&id=6c18f1db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c18f1db"]])

export default __exports__